import { observer } from "mobx-react-lite";
import { Col, Row, Select } from "antd";
import { useStore } from "../../stores/root-store-context";

export const SelectProperty = observer(() => {
  const { applicationStore } = useStore();
  return (
    <div className="mat__search-row">
      <div className="mat__search-col" style={{ maxWidth: "20rem" }}>
        <b>Property</b>
      </div>
      <div className="mat__search-col" style={{ maxWidth: "20rem" }}>
        <Select
          data-testid="mat-select-property"
          onSelect={(id) => {
            applicationStore
              .changeProperty(
                applicationStore.propertyList.find((el) => el.id === id)
              )
              .catch(console.error);
          }}
          placeholder={<b>Please enter property...</b>}
          showSearch
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input.toLocaleLowerCase()
            )
          }
          options={applicationStore.propertyList.map((el, index) => {
            return {
              key: index,
              value: el.id,
              label: `${el.name} (${el.id})`,
            };
          })}
        />
      </div>
    </div>
  );
});